import FormControl from '@mui/material/FormControl';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';
import { FC, ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { MdLaptopMac, MdOutlineLocationOn, MdSyncAlt } from 'react-icons/md';

import { TProFormValues } from './steps';

const FORMAT_OPTIONS: Array<{ value: string; label: string; icon: ReactNode }> = [
  { value: 'in_person', label: 'In person', icon: <MdOutlineLocationOn size={18} /> },
  { value: 'online', label: 'Online', icon: <MdLaptopMac size={18} /> },
  { value: 'both', label: 'Both', icon: <MdSyncAlt size={18} /> },
];

type Props = {
  isPending: boolean;
};

export const ProDirectoryTeachingFormatCards: FC<Props> = ({ isPending }) => {
  const { control } = useFormContext<TProFormValues>();

  return (
    <Controller
      name="teachingFormat"
      control={control}
      render={({ field, fieldState }) => (
        <FormControl error={!!fieldState.error}>
          <ToggleButtonGroup
            value={field.value ?? null}
            exclusive
            size="small"
            color="info"
            disabled={isPending}
            onChange={(_, next: string | null) => field.onChange(next ?? undefined)}
            sx={{
              width: '100%',
              maxWidth: 400,
              height: 45,
              flexWrap: 'nowrap',
              '& .MuiToggleButtonGroup-firstButton': {
                borderTopLeftRadius: 12,
                borderBottomLeftRadius: 12,
              },
              '& .MuiToggleButtonGroup-lastButton': {
                borderTopRightRadius: 12,
                borderBottomRightRadius: 12,
              },
            }}
          >
            {FORMAT_OPTIONS.map(option => (
              <ToggleButton
                key={option.value}
                value={option.value}
                sx={{
                  gap: 0.5,
                  flex: 1,
                  minWidth: 0,
                }}
              >
                {option.icon}
                {option.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
          {fieldState.error && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
              {fieldState.error.message}
            </Typography>
          )}
        </FormControl>
      )}
    />
  );
};
